(() => {
  const playVisibleVideos = (swiperEl) => {
    const videos = swiperEl.querySelectorAll(".slideshow__video video");

    if (swiperEl.swiper && swiperEl.swiper.initialized) {
      videos.forEach((video) => {
        const shouldPlay = Boolean(video.closest(".swiper-slide-visible"));
        if (window.ThemeVideo?.syncSlideshowVideo) {
          window.ThemeVideo.syncSlideshowVideo(video, shouldPlay);
        } else if (shouldPlay) {
          window.ThemeVideo?.playIfBackground(video);
        } else {
          video.pause();
        }
      });
    } else if (swiperEl.closest('[data-slide-count="1"]')) {
      videos.forEach((video) => {
        if (window.ThemeVideo?.syncSlideshowVideo) {
          window.ThemeVideo.syncSlideshowVideo(video, true);
        } else {
          window.ThemeVideo?.playIfBackground(video);
        }
      });
    }
  };

  const updateColorScheme = (swiper) => {
    const viewportWidth =
      window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const activeSlide = swiper.slides[swiper.activeIndex];
    let breakpoint = 0;
    let parentEl;

    if (swiper.el.parentNode.classList.contains("slideshow__swiper--simple")) {
      parentEl = swiper.el.parentNode;
      breakpoint = 990;
    }

    if (
      swiper.el.classList.contains("slideshow__swiper--overlay") ||
      swiper.el.classList.contains("slideshow__swiper--grid")
    ) {
      breakpoint = 0;
    }

    const elements = [
      swiper.navigation?.nextEl,
      swiper.navigation?.prevEl,
      swiper.pagination?.el,
      ...(parentEl ? [parentEl] : []),
    ].filter(Boolean);

    if (viewportWidth >= breakpoint) {
      const colorScheme = activeSlide?.dataset.colorScheme;
      elements.forEach((el) => {
        if (!el) return;
        let className = el.getAttribute("class");
        className = className.replace(/color-background-\d+/g, "");
        el.setAttribute("class", className);
        if (colorScheme) el.classList.add(colorScheme);
      });
    } else {
      elements.forEach((el) => {
        if (!el) return;
        let className = el.getAttribute("class");
        className = className.replace(/color-background-\d+/g, "");
        el.setAttribute("class", className);
      });
    }
  };

  const renderProgressPagination = (swiper, current, total) => {
    let html = "";
    for (let i = 1; i <= total; i++) {
      const activeClass = i === current ? " swiper-pagination-bullet-active" : "";
      html += `<span class="swiper-pagination-bullet${activeClass}" aria-hidden="true"></span>`;
    }
    return html;
  };

  const isDesktopSlideshow = () =>
    window.matchMedia("(min-width: 990px)").matches;

  const INTERACTIVE_SELECTOR =
    "a, button, input, textarea, select, .slideshow__button-wrapper, .slideshow__content-group, .slideshow__bottom--progress";

  const isInteractiveTarget = (target) => target.closest(INTERACTIVE_SELECTOR);

  const clearSlideshowCursor = (swiperEl) => {
    swiperEl.classList.remove("is-slideshow-cursor-prev", "is-slideshow-cursor-next");
  };

  const bindSlideNavigation = (swiperEl, getSwiper) => {
    if (!swiperEl) return;

    const updateCursor = (event) => {
      if (!isDesktopSlideshow() || isInteractiveTarget(event.target)) {
        clearSlideshowCursor(swiperEl);
        return;
      }

      const rect = swiperEl.getBoundingClientRect();
      const isPrev = event.clientX - rect.left < rect.width / 2;
      swiperEl.classList.toggle("is-slideshow-cursor-prev", isPrev);
      swiperEl.classList.toggle("is-slideshow-cursor-next", !isPrev);
    };

    swiperEl.addEventListener("click", (event) => {
      if (!isDesktopSlideshow() || isInteractiveTarget(event.target)) return;

      const swiper = getSwiper();
      if (!swiper || swiper.destroyed) return;

      const rect = swiperEl.getBoundingClientRect();
      if (event.clientX - rect.left < rect.width / 2) swiper.slidePrev();
      else swiper.slideNext();
    });

    swiperEl.addEventListener("mousemove", updateCursor);
    swiperEl.addEventListener("mouseleave", () => clearSlideshowCursor(swiperEl));
  };

  const initSlideshow = (sectionEl) => {
    if (!sectionEl || !sectionEl.classList.contains("section-slideshow")) return;

    new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const slideshow = sectionEl.querySelector(".slideshow");
        if (!slideshow) return;

        const prevBtn = slideshow.querySelector(".swiper-button-prev");
        const nextBtn = slideshow.querySelector(".swiper-button-next");
        const paginationEl = slideshow.querySelector(".slideshow__pagination");

        const commonConfig = {
          speed: 800,
          effect: "slide",
          autoHeight: false,
          allowTouchMove: true,
          mousewheel: { forceToAxis: true },
          keyboard: { enabled: false },
          watchSlidesProgress: true,
          preventInteractionOnTransition: true,
        };

        if (slideshow.getAttribute("data-autoplay") === "true") {
          commonConfig.autoplay = { disableOnInteraction: true };
        }

        if (slideshow.getAttribute("data-pagination") === "true" && paginationEl) {
          commonConfig.pagination = {
            el: paginationEl,
            type: "custom",
            renderCustom: renderProgressPagination,
          };
        }

        if (slideshow.getAttribute("data-navigation") === "true") {
          commonConfig.navigation = {
            nextEl: nextBtn,
            prevEl: prevBtn,
          };
        }

        if (
          slideshow.getAttribute("data-parallax") === "true" &&
          slideshow.getAttribute("data-layout") !== "grid"
        ) {
          commonConfig.parallax = true;
        }

        if (slideshow.getAttribute("data-enable-loop") === "true") {
          commonConfig.loop = true;
        }

        const slideCount = Number(slideshow.getAttribute("data-slide-count"));
        if (slideCount <= 1) return;

        const layout = slideshow.getAttribute("data-layout");

        if (layout === "simple") {
          const textSwiper = slideshow.querySelector(".slideshow__swiper--text");
          const mediaSwiper = slideshow.querySelector(".slideshow__swiper--media");
          if (!textSwiper || !mediaSwiper) return;

          const textInstance = new Swiper(textSwiper, commonConfig);
          const mediaInstance = new Swiper(mediaSwiper, {
            ...commonConfig,
            autoplay: false,
            pagination: false,
            navigation: false,
            parallax: false,
          });

          textInstance.controller.control = mediaInstance;
          mediaInstance.controller.control = textInstance;

          updateColorScheme(textInstance);
          textInstance.on("beforeTransitionStart", function () {
            updateColorScheme(this);
          });
          mediaInstance.on("beforeTransitionStart", function () {
            updateColorScheme(textInstance);
          });
          mediaInstance.on("slideChange", function () {
            playVisibleVideos(mediaSwiper);
          });

          bindSlideNavigation(mediaSwiper, () => textInstance);
        } else if (layout === "overlay") {
          const overlaySwiper = slideshow.querySelector(".slideshow__swiper--overlay");
          if (!overlaySwiper) return;

          const instance = new Swiper(overlaySwiper, commonConfig);

          updateColorScheme(instance);
          instance.on("beforeTransitionStart", function () {
            updateColorScheme(this);
          });
          instance.on("slideChange", function () {
            playVisibleVideos(overlaySwiper);
          });

          bindSlideNavigation(overlaySwiper, () => instance);
        } else if (layout === "grid") {
          const gridConfig = { ...commonConfig };
          gridConfig.breakpoints = { 750: { slidesPerView: "auto" } };

          const gridSwiper = slideshow.querySelector(".slideshow__swiper--grid");
          if (!gridSwiper) return;

          const instance = new Swiper(gridSwiper, gridConfig);
          updateColorScheme(instance);
          instance.on("beforeTransitionStart", function () {
            updateColorScheme(this);
          });
          instance.on("slideChange", function () {
            playVisibleVideos(gridSwiper);
          });

          bindSlideNavigation(gridSwiper, () => instance);
        }
      });
    }).observe(sectionEl);
  };

  const initAutoplayObserver = (sectionEl) => {
    if (!sectionEl || !sectionEl.classList.contains("section-slideshow")) return;

    const slideshow = sectionEl.querySelector(".slideshow");
    if (!slideshow) return;

    let mediaSwiperEl;
    const layout = slideshow.getAttribute("data-layout");

    if (layout === "simple") {
      mediaSwiperEl = sectionEl.querySelector(".slideshow__swiper--media");
    } else if (layout === "overlay") {
      mediaSwiperEl = sectionEl.querySelector(".slideshow__swiper--overlay");
    } else if (layout === "grid") {
      mediaSwiperEl = sectionEl.querySelector(".slideshow__swiper--grid");
    }

    new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (mediaSwiperEl) {
            playVisibleVideos(mediaSwiperEl);
            if (mediaSwiperEl.swiper && slideshow.getAttribute("data-autoplay") === "true") {
              mediaSwiperEl.swiper.autoplay.resume();
            }
          }
        } else if (mediaSwiperEl) {
          const videos = mediaSwiperEl.querySelectorAll(".slideshow__video video");
          if (mediaSwiperEl.swiper && mediaSwiperEl.swiper.initialized) {
            videos.forEach((video) => {
              window.ThemeVideo?.syncSlideshowVideo?.(video, false);
            });
          } else if (mediaSwiperEl.closest('[data-slide-count="1"]')) {
            videos.forEach((video) => {
              window.ThemeVideo?.syncSlideshowVideo?.(video, true);
            });
          }

          if (mediaSwiperEl.swiper && slideshow.getAttribute("data-autoplay") === "true") {
            mediaSwiperEl.swiper.autoplay.pause();
          }
        }
      });
    }).observe(sectionEl);
  };

  const sectionEl = document.currentScript.parentElement;
  initSlideshow(sectionEl);
  initAutoplayObserver(sectionEl);

  document.addEventListener("shopify:section:load", (event) => {
    initSlideshow(event.target);
    initAutoplayObserver(event.target);
  });
})();
